module.exports = __webpack_public_path__ + "img/clock-two.ea406ed3.svg";